import React from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';

export const FAQSection: React.FC = () => {
    const faqs = [
        {
            question: "Is this CV editor free to use?",
            answer: "Yes, our CV editor is completely free. You can create, edit, and download your professional resume without any hidden costs or subscription fees."
        },
        {
            question: "Is the generated resume ATS friendly?",
            answer: "Absolutely. Our templates are designed to be fully compatible with Applicant Tracking Systems (ATS). We use standard formatting and clean code structure to ensure your CV is parsed correctly by hiring software."
        },
        {
            question: "How can I download my resume?",
            answer: "Once you've finished editing your CV, simply click the 'Imprimer / PDF' button in the top navigation bar. This will open the print dialog where you can save the document as a PDF file."
        },
        {
            question: "Is my personal data private?",
            answer: "Yes, your privacy is our priority. We do not store your personal data on our servers. All editing happens locally in your browser, ensuring your information remains secure and private."
        },
        {
            question: "Can I customize the colors and layout?",
            answer: "Yes! You can choose from multiple professional templates (Modern, Minimalist, Classic, etc.) and customize the theme color to match your personal brand."
        }
    ];

    return (
        <section className="bg-white py-16 border-t border-slate-200 print:hidden" aria-labelledby="faq-heading">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 id="faq-heading" className="text-3xl font-bold text-slate-900 flex items-center justify-center gap-3">
                        <HelpCircle className="w-8 h-8 text-sky-600" />
                        Frequently Asked Questions
                    </h2>
                    <p className="mt-4 text-lg text-slate-600">
                        Everything you need to know about creating your professional CV.
                    </p>
                </div>

                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <details
                            key={index}
                            className="group bg-slate-50 rounded-lg border border-slate-200 open:bg-white open:ring-1 open:ring-sky-100 transition-all duration-200"
                        >
                            <summary className="flex justify-between items-center cursor-pointer p-6 font-medium text-slate-900 list-none select-none">
                                <span className="text-lg">{faq.question}</span>
                                <ChevronDown className="w-5 h-5 text-slate-500 transition-transform duration-200 group-open:rotate-180 group-open:text-sky-600" />
                            </summary>
                            <div className="px-6 pb-6 text-slate-600 leading-relaxed animate-in fade-in slide-in-from-top-2 duration-200">
                                {faq.answer}
                            </div>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    );
};
